function setHeaderHeightVar() {
  const stickyHeader = document.querySelector('sticky-header');
  if (!stickyHeader) return;

  const header = stickyHeader.querySelector('header');
  document.documentElement.style.setProperty('--cabrio-header-height', `${stickyHeader.offsetHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${stickyHeader.offsetHeight}px`);

  if (!header) return;

  // Fila 1: el primer elemento visible (querySelector devuelve en orden DOM, no en orden del selector)
  const line1El = ['.header__lettering--text-only', '.header__lettering--with-icon', 'header-drawer']
    .map(sel => header.querySelector(sel))
    .find(el => el && el.offsetHeight > 0);
  // Fila 2: el nav del sidebar
  const line2El = header.querySelector('.header__sidebar-nav');

  if (line1El) {
    // getBoundingClientRect da la altura real incluyendo el espacio que ocupa en el grid
    const line1Bottom = line1El.getBoundingClientRect().bottom;
    const headerTop   = header.getBoundingClientRect().top;
    const line1Height = line1Bottom - headerTop;
    document.documentElement.style.setProperty('--header-line1-height', `${line1Height}px`);
  }

  if (line2El) {
    document.documentElement.style.setProperty('--header-line2-height', `${line2El.offsetHeight}px`);
  }
}

window.addEventListener('load', setHeaderHeightVar);
window.addEventListener('resize', setHeaderHeightVar);

// Collection móvil: fondo blanco al hacer scroll
document.addEventListener('DOMContentLoaded', function() {
  if (!document.body.classList.contains('template-collection')) return;

  var stickyHeader = document.querySelector('sticky-header');
  if (!stickyHeader) return;

  function onScroll() {
    if (window.innerWidth >= 990) {
      stickyHeader.classList.remove('scrolled-mobile');
      return;
    }
    if (window.scrollY > 10) {
      stickyHeader.classList.add('scrolled-mobile');
    } else {
      stickyHeader.classList.remove('scrolled-mobile');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll(); // ejecutar al cargar
});
  

  document.addEventListener('DOMContentLoaded', function(){
    const swatchLinks = document.querySelectorAll('.swatch__link[data-hover-img][data-hover-srcset]');
    
    swatchLinks.forEach(function(link) {
      link.addEventListener('mouseenter', function(){
        const hoverImgUrl = link.getAttribute('data-hover-img');
        const hoverSrcset = link.getAttribute('data-hover-srcset');
        const card = link.closest('.card-wrapper');
        if(card){
          const hoverImg = card.querySelector('.card__media img:not(.product-first-media)');
          if(hoverImg){
            if(!hoverImg.getAttribute('data-default-src')){
              hoverImg.setAttribute('data-default-src', hoverImg.getAttribute('src'));
              hoverImg.setAttribute('data-default-srcset', hoverImg.getAttribute('srcset'));
            }
            hoverImg.setAttribute('src', hoverImgUrl);
            hoverImg.setAttribute('srcset', hoverSrcset);
          }
        }
      });
      
      link.addEventListener('mouseleave', function(){
        const card = link.closest('.card-wrapper');
        if(card){
          const hoverImg = card.querySelector('.card__media img:not(.product-first-media)');
          if(hoverImg && hoverImg.getAttribute('data-default-src')){
            hoverImg.setAttribute('src', hoverImg.getAttribute('data-default-src'));
            hoverImg.setAttribute('srcset', hoverImg.getAttribute('data-default-srcset'));
          }
        }
      });
    });
  });
  
  document.addEventListener('DOMContentLoaded', () => {
    const details = document.querySelectorAll('details[id^="Details-HeaderMenu-"]');

    details.forEach(detail => {
      const summary = detail.querySelector('summary');

      summary.addEventListener('mouseenter', () => {
        detail.setAttribute('open', '');
      });

      detail.addEventListener('mouseleave', () => {
        detail.removeAttribute('open');
      });
    });
  });
